
export default function DeviceModels() {
  const devices = [
    {
      name: 'iPhone 15 Pro Max',
      price: '150,000원부터',
      image: 'https://public.readdy.ai/ai/img_res/99f0aba382c4a1507716e32bdca08a86.jpg',
      isLatest: true,
    },
    {
      name: 'iPhone 14 Series',
      price: '120,000원부터',
      image: 'https://readdy.ai/api/search-image?query=iPhone%2014%20Pro%20on%20clean%20white%20background%2C%20purple%20color%20iPhone%2C%20premium%20smartphone%20display%2C%20professional%20product%20shot%2C%20elegant%20presentation&width=400&height=500&seq=device-002&orientation=portrait',
      isLatest: false,
    },
    {
      name: 'iPhone 13 Series',
      price: '100,000원부터',
      image: 'https://readdy.ai/api/search-image?query=iPhone%2013%20on%20clean%20white%20background%2C%20blue%20color%20iPhone%2C%20modern%20smartphone%2C%20professional%20product%20photography%2C%20simple%20presentation&width=400&height=500&seq=device-003&orientation=portrait',
      isLatest: false,
    },
    {
      name: 'iPhone 12 Series',
      price: '90,000원부터',
      image: 'https://readdy.ai/api/search-image?query=iPhone%2012%20on%20clean%20white%20background%2C%20black%20color%20iPhone%2C%20sleek%20smartphone%20design%2C%20professional%20product%20shot&width=400&height=500&seq=device-004&orientation=portrait',
      isLatest: false,
    },
    {
      name: 'iPhone 11 Series',
      price: '80,000원부터',
      image: 'https://readdy.ai/api/search-image?query=iPhone%2011%20on%20clean%20white%20background%2C%20green%20color%20iPhone%2C%20modern%20smartphone%2C%20professional%20product%20photography&width=400&height=500&seq=device-005&orientation=portrait',
      isLatest: false,
    },
    {
      name: 'iPhone X/XS/XR',
      price: '70,000원부터',
      image: 'https://readdy.ai/api/search-image?query=iPhone%20X%20on%20clean%20white%20background%2C%20silver%20color%20iPhone%2C%20elegant%20smartphone%20design%2C%20professional%20product%20shot&width=400&height=500&seq=device-006&orientation=portrait',
      isLatest: false,
    },
    {
      name: 'iPad Series',
      price: '100,000원부터',
      image: 'https://readdy.ai/api/search-image?query=iPad%20Pro%20on%20clean%20white%20background%2C%20modern%20tablet%20device%2C%20professional%20product%20photography%2C%20minimalist%20presentation&width=400&height=500&seq=device-007&orientation=portrait',
      isLatest: false,
    },
    {
      name: '구형 모델',
      price: '60,000원부터',
      image: 'https://readdy.ai/api/search-image?query=iPhone%208%20and%20older%20models%20on%20clean%20white%20background%2C%20classic%20iPhone%20design%2C%20professional%20product%20photography&width=400&height=500&seq=device-008&orientation=portrait',
      isLatest: false,
    },
  ];

  return (
    <section className="py-24 bg-[#F5F5F0]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">수리 가능 기종</h2>
          <p className="text-gray-600 text-base">iPhone 3GS부터 최신 기종까지</p>
        </div>

        <div className="overflow-x-auto pb-6 -mx-6 px-6">
          <div className="flex gap-6 min-w-max">
            {devices.map((device, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 w-72 flex-shrink-0 transform hover:-translate-y-2"
              >
                {device.isLatest && (
                  <div className="p-4">
                    <span className="inline-block bg-[#1a1a1a] text-white text-xs font-bold px-3 py-1 rounded-full">
                      최신
                    </span>
                  </div>
                )}
                <div className="relative h-80 bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center p-8">
                  <img
                    src={device.image}
                    alt={device.name}
                    className="w-full h-full object-contain"
                  />
                </div>
                <div className="p-6 text-center">
                  <h3 className="text-lg font-bold text-gray-900 mb-2">{device.name}</h3>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="text-center mt-12">
          <p className="text-gray-700 text-base">
            <i className="ri-information-line text-[#007AFF] mr-2"></i>
            수리 가격은 증상에 따라 달라질 수 있습니다
          </p>
        </div>
      </div>
    </section>
  );
}
